import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { GeolocationService } from './geolocation.service';
import { FormattedAddressDirective } from './formatted-address/formatted-address.directive'

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    FormattedAddressDirective
  ],
  declarations: [FormattedAddressDirective],
  providers: [GeolocationService]
})
export class GeolocationModule { }

export { GeolocationService, FormattedAddressDirective }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/geolocation/geolocation.module.ts